import { render } from "./FutureObligation.vue?vue&type=template&id=9d6b856c"
import script from "./FutureObligation.vue?vue&type=script&lang=js"
export * from "./FutureObligation.vue?vue&type=script&lang=js"

import "./FutureObligation.vue?vue&type=style&index=0&id=9d6b856c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__